<template>
  <div>
    <MenuPromotion/>
    <Promotion_assorted/>
  </div>
</template>

<script>
import MenuPromotion from "@/components/admin/stock/storage_promotion/menupromotion/MenuPromotion";
import Promotion_assorted from "@/components/admin/stock/storage_promotion/Promotion_assorted";
export default {
  name: "PromotionAssorted",
  components: {
    Promotion_assorted,
    MenuPromotion
  }
}
</script>

<style scoped>

</style>